// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gx-a";
export var fulfillmentFormRail = "_gx-9";
export var headerTitleRow = "_gx-c";
export var orderDetailsWrapper = "_gx-7";
export var orderLinkTrigger = "_gx-2";
export var paymentInformationGrid = "_gx-h";
export var paymentSummaryColumn = "_gx-i";
export var shipmentContainer = "_gx-b";
export var shipmentDetailsMainPane = "_gx-8";
export var shipmentNavigationCard = "_gx-5";
export var shipmentNavigationRail = "_gx-3";
export var shipmentNavigationRailHeader = "_gx-4";
export var shipmentSummaryFact = "_gx-e";
export var shipmentSummaryGrid = "_gx-d";
export var shipmentSummaryMetadataRow = "_gx-f";
export var shipmentSummaryTags = "_gx-g";
export var shipmentWorkspace = "_gx-0";
export var shipmentWorkspaceContent = "_gx-6";
export var shipmentWorkspaceHeader = "_gx-1";